import { useEffect } from 'react';
import { toast } from 'sonner';

const LAST_ACTIVITY_KEY = 'lastActivityAt';
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

// Logs the user out after `minutes` of no interaction (shared front-desk PCs).
export default function useIdleLogout(active, onLogout, minutes = 60) {
  useEffect(() => {
    if (!active) {
      localStorage.removeItem(LAST_ACTIVITY_KEY);
      return undefined;
    }
    const limitMs = minutes * 60 * 1000;
    let last = Number(localStorage.getItem(LAST_ACTIVITY_KEY)) || Date.now();
    localStorage.setItem(LAST_ACTIVITY_KEY, String(last));

    let throttle = 0;
    const touch = () => {
      const now = Date.now();
      if (now - throttle < 5000) return;
      throttle = now;
      last = now;
      localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
    };

    const check = () => {
      const stored = Number(localStorage.getItem(LAST_ACTIVITY_KEY)) || last;
      if (Date.now() - stored >= limitMs) {
        localStorage.removeItem(LAST_ACTIVITY_KEY);
        onLogout();
        toast.info('You were signed out after 60 minutes of inactivity.');
        window.location.href = '/login?reason=idle';
      }
    };

    EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const timer = setInterval(check, 30 * 1000);
    check();
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, touch));
      clearInterval(timer);
    };
  }, [active, onLogout, minutes]);
}
